import { render, staticRenderFns } from "./TransferClinicDrugbook.vue?vue&type=template&id=3df78154&"
import script from "./TransferClinicDrugbook.vue?vue&type=script&lang=js&"
export * from "./TransferClinicDrugbook.vue?vue&type=script&lang=js&"
import style0 from "./TransferClinicDrugbook.vue?vue&type=style&index=0&id=3df78154&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports